import { render, staticRenderFns } from "./LoginCidaas.vue?vue&type=template&id=1be009ed&"
import script from "./LoginCidaas.vue?vue&type=script&lang=js&"
export * from "./LoginCidaas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports